import { lazy } from "react";
import HelpCenterHome from "./home/HelpCenterHome";
import HelpCenterFaqs from "./faqs/HelpCenterFaqs";
import HelpCenterGuides from "./guides/HelpCenterGuides";
import HelpCenterSupport from "./support/HelpCenterSupport";
import GuideCategory from "./guides/GuideCategory";
import GuideCategories from "./guides/GuideCategories";
import HelpCenterGuide from "./guide/HelpCenterGuide";
import i18next from "i18next";
import en from "./i18n/en";
import bg from "./i18n/bg";

i18next.addResourceBundle("en", "helpCenter", en);
i18next.addResourceBundle("bg", "helpCenter", bg);

const HelpCenterApp = lazy(() => import("./HelpCenterApp"));

/**
 * The help center app config.
 */
const HelpCenterAppConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "/help-center",
      element: <HelpCenterApp />,
      children: [
        {
          path: "home",
          element: <HelpCenterHome />,
        },
        // {
        //   path: "faqs",
        //   element: <HelpCenterFaqs />,
        // },
        {
          path: "guides",
          element: <HelpCenterGuides />,
          children: [
            {
              path: "",
              element: <GuideCategories />,
            },
            {
              path: ":categorySlug",
              element: <GuideCategory />,
            },
            {
              path: ":categorySlug/:guideSlug",
              element: <HelpCenterGuide />,
            },
          ],
        },
        // {
        //   path: "support",
        //   element: <HelpCenterSupport />,
        // },
      ],
    },
  ],
};

export default HelpCenterAppConfig;
